import React, { useState } from "react";
import { ViewInfoModal } from "../modal";

import "./function.css";

export default function Function6({ data }) {
  const [onView, setOnView] = useState(false);
  return (
    <React.Fragment>
      <td>
        <div className="d-flex justify-content-center py-2">
          <div style={{ width: "90%" }}>
            <div className="d-flex justify-content-between">
              <div>
                <span className="font-weight-bold mr-1">{`功率:`}</span>
                <span className="mr-2 text-nowrap">{data.status !== "-1" ? data["P_total"] : "--"} (w)</span>
              </div>
              <div>
                <span className="font-weight-bold mr-1">{`漏電流:`}</span>
                <span className="mr-2 text-nowrap">{data.status !== "-1" ? data["I_leak"] : "--"}(A)</span>
              </div>
              <button type="button" onClick={() => setOnView(true)}>
                查看
              </button>
            </div>
          </div>
        </div>
        <div>
          <ViewInfoModal open={onView} setOnView={setOnView} data={data} />
        </div>
      </td>
    </React.Fragment>
  );
}
